import { createAction } from "@reduxjs/toolkit";
import { AfterPurchaseTask } from "state/tree/afterPurchaseTaskManager";

export default {
  processFirstQueueItem: createAction("lwc/user/processFirstQueueItem"),
  setItemAfterCoinsBuy: createAction<AfterPurchaseTask>(
    "lwc/user/setItemAfterBuy"
  ),
};
